module.exports = __webpack_public_path__ + "img/shield-blank.36ccf4d3.svg";